import { PaymentMethodType, Currency } from '@40seas/models';

export const stripePaymentMethodsMapper = new Map<PaymentMethodType, string>([
    [PaymentMethodType.Card, 'card'],
    [PaymentMethodType.Wire, 'customer_balance'],
    [PaymentMethodType.ACH, 'us_bank_account'],
    [PaymentMethodType.ACSS, 'acss_debit'],
    [PaymentMethodType.BACS, 'bacs_debit'],
    [PaymentMethodType.Stablecoin, 'crypto'],
]);

export const STRIPE_MINIMUM_PAYMENT_AMOUNT = 0.5;

export enum ProviderAdjustmentDirection {
    To = 'To',
    From = 'From',
}

const ZERO_DECIMAL_CURRENCIES = [
    Currency.CLP,
    Currency.MGA,
    Currency.RWF,
    Currency.VND,
    Currency.XAF,
    Currency.XOF,
    Currency.JPY,
    Currency.KRW,
    Currency.PYG,
];

const TRANSITION_ZERO_DECIMAL_CURRENCIES = [Currency.ISK];

export const adjustAmount = (
    amount: number,
    direction: ProviderAdjustmentDirection = ProviderAdjustmentDirection.To,
    currency?: Currency,
): number => {
    if (currency && ZERO_DECIMAL_CURRENCIES.includes(currency)) {
        return Math.round(amount);
    }

    if (currency && TRANSITION_ZERO_DECIMAL_CURRENCIES.includes(currency)) {
        amount = Math.round(amount);
    }

    const toStripe = direction === ProviderAdjustmentDirection.To;
    const adjusted = toStripe ? amount * 100 : amount / 100;
    return toStripe ? +adjusted.toFixed() : adjusted;
};

export const adjustAmountForAirwallex = (amount: number, currency?: Currency): number => {
    if (currency && ZERO_DECIMAL_CURRENCIES.includes(currency)) {
        return Math.round(amount);
    }

    return Math.round(amount * 100) / 100;
};

export const getStatementDescriptor = (sellerName: string, descriptorBrand = '40Seas'): string => {
    return `${sellerName.substring(0, 15)}-${descriptorBrand}`;
};

export const isReevolApiRequestHost = (hostHeader?: string | string[]): boolean => {
    const host = (Array.isArray(hostHeader) ? hostHeader[0] : hostHeader || '').toLowerCase();
    if (!host) {
        return false;
    }

    return host.split(':')[0] === 'api.reevol.com';
};
